import { Grid } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { employeeRequests } from "api/employeeApi";
import { settings } from "app";
import { studentRequests } from "api/studentApi";
import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { FunctionField, Labeled, ReferenceField, Show, SimpleShowLayout, TextField } from "react-admin";
import { getProfessorRecordText } from "server/components/Fields/_fieldsHelper";
import RoomField from "server/components/Fields/RoomField";
import { CourseChoices, FromWeekToWeekChoices, WeekDaysChoices, WeekTypeChoices } from "utils/choices";
import { SectionTitle } from "features/SectionTitle";

const ShowSportSchedule = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <Show
      title="Детайли на Разписания чужди езици"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Спорт">
              <TextField source="sportNameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Семестър">
              <ReferenceField
                source="academicSessionId"
                reference={studentRequests.getAcademicSessionsSelect()}
              >
                <TextField source="sessionTypeText" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Преподавател">
              <ReferenceField
                source="professorEmployeeId"
                reference={employeeRequests.getProfessorsSelect()}
                linkType={false}
              >
                <FunctionField render={getProfessorRecordText} />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Курс">
              <FunctionField render={record => CourseChoices.find(option => option.id === record.course)?.name} />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="От седмица">
              <FunctionField render={record => FromWeekToWeekChoices.find(d => d.id === record.fromWeek)?.name} />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="До седмица">
              <FunctionField render={record => FromWeekToWeekChoices.find(d => d.id === record.toWeek)?.name} />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Тип седмица">
              <FunctionField render={record => WeekTypeChoices.find(d => d.id === record.weekType)?.name} />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Ден">
              <FunctionField render={record => WeekDaysChoices.find(d => d.id === record.weekDay)?.name} />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Зала">
              <RoomField />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="От">
              <TextField source="startTime" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="До">
              <TextField source="endTime" />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowSportSchedule;
